import { cart_drawer } from 'cart_drawer';
import { logo_3d } from 'logo_3d';

(() => {

const body = document.body;

const html = document.documentElement;
const lockScroll = () => {
  html.style.overflow = 'hidden';
  body.classList.add('modal-open');
};
const unlockScroll = () => {
  html.style.overflow = '';
  body.classList.remove('modal-open');
};

let winW = window.innerWidth;
let winH = window.innerHeight;
window.addEventListener('resize', function(){
	winW = window.innerWidth;
	winH = window.innerHeight;
});

var ofstY = 20;
function anchorLink(){
  const anchor = document.querySelectorAll('.anchor');
  anchor.forEach((el) => {
    el.addEventListener('click', (e) => {
      const href = e.currentTarget.getAttribute('href');
      const url = new URL(href, location.origin);
      const isHashOnly = href && href.startsWith('#');
      const isSamePage = isHashOnly || (url.pathname === location.pathname);
      if (isSamePage && url.hash) {
        e.preventDefault();
        body.classList.remove('navopen');
        gsap.to(window, { duration:0.6, scrollTo:{y:url.hash, autoKill:false, offsetY:ofstY}, ease:'power2'});
      }
    });
  });
}


function modalFunc() {
  const modalBtns = document.querySelectorAll('.modalbtn');
  modalBtns.forEach((btn) => {
    btn.addEventListener('click', function () {
      if(body.classList.contains('modal-open')){
        unlockScroll();
        const modals = document.querySelectorAll('.modal');
        modals.forEach((modal) => {
          modal.classList.remove('is-open');
        });
        return;
      }
      const modalId = btn.getAttribute('data-modal');
      const modal = document.getElementById(modalId);
      if (modal) {
        if (modal.classList.contains('is-open')) {
          modal.classList.remove('is-open');
          unlockScroll();
        } else {
          cartDrawerInstance.close();
          modal.classList.add('is-open');
          lockScroll();
        }
      }
    });
  });

  const modals = document.querySelectorAll('.modal');
  modals.forEach((modal) => {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        modal.classList.remove('is-open');
        unlockScroll();
      }
    });
  });
}


function navInit() {
  const nav_anchor = () => {
    const navlinks = document.querySelectorAll('#main_nav a');
    navlinks.forEach((link) => {
      if (link.hash) {
        link.classList.add('anchor');
        link.addEventListener('click', (e) => {
          unlockScroll();
          const modals = document.querySelectorAll('.modal');
          modals.forEach((modal) => {
            modal.classList.remove('is-open');
          });
        });
      }
    });
  }
  nav_anchor();

  const nav_exlink = () => {
    const navlinks = document.querySelectorAll('#main_nav a');
    navlinks.forEach((link) => {
      if(link.hostname !== location.hostname){
        link.setAttribute('target', '_blank');
      }
    });
  }
  nav_exlink();
}

function elFunc(){
	let mm = gsap.matchMedia();
	document.querySelectorAll('.el').forEach((_tar, i) => {
		let _elmc = _tar.querySelectorAll('.elc');
		if( _elmc.length == 0 ){
			_elmc = _tar;
		}
		gsap.set(_elmc,{ opacity:0, y:0 });
		gsap.to(_elmc,
			{ opacity:1, y:0, 
				duration: 1.2,
				ease: "power4.out",
 				stagger: 0.1,
				scrollTrigger: {
					trigger: _tar,
					start: "top bottom-=10%",
					onRefresh: self => self.progress === 1 && self.animation.progress(1),
				},
				onStart: function(){
					_tar.classList.add('elon');
				}
			}
		);
	});

	const up_scrollTrigger = ScrollTrigger.create({
		trigger: body,
		start: "top top",
		onUpdate: self => {
			const _slfscrl = self.scroll();
			if(self.direction == -1){
				document.body.classList.remove('scrldown');
			}else{
				if(_slfscrl > 10){
					if(self.prevSclrl < _slfscrl-1){
						document.body.classList.add('scrldown');
					}
					self.prevSclrl = _slfscrl;
				}
			}
			scrltop (_slfscrl);
		},
	});
	document.body.classList.add('scrltop');
}
const scrltop = (_slfscrl) => {
	if(_slfscrl > 10){
		document.body.classList.remove('scrltop');
		document.body.classList.add('scrl');
	}else{
		document.body.classList.remove('scrl');
		document.body.classList.add('scrltop');
	}
}


function imageSlide(){
  let swiper;
  const initSwiper = () => {
    if (window.innerWidth <= 767 && !swiper) {
      swiper = new Swiper('.item_slider', {
        slidesPerView: 1,
        speed: 200,
        spaceBetween: 0,
        loop: true,
        keyboard: {
          enabled: false,
        },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
      });
    } else if (window.innerWidth > 767 && swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
  }
  initSwiper();  
  window.addEventListener('resize', initSwiper);
}



function recommendSlide(){
  const gap = getComputedStyle(document.documentElement).getPropertyValue('--gap');
  const gapInPx = parseFloat(gap) * 10;

  const recommendSwiper = document.querySelectorAll('.recommend_swiper');
  recommendSwiper.forEach((swiper) => {
    const swiperInstance = new Swiper(swiper, {
      slidesPerView: 2,
      speed: 600,
      spaceBetween: 15,
      keyboard: {
        enabled: false,
      },
      navigation: {
        nextEl: '.sw_next',
        prevEl: '.sw_prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 40,
        },
      },
    });
  });
}


// Shopify Forms Customization
function setShopifyFormsColor() {
  document.querySelectorAll('shopify-forms-embed').forEach(form => {
    if (form.shadowRoot && form.shadowRoot.host) {
      form.shadowRoot.host.style.setProperty('--form-text-color', '#00884d');
      form.shadowRoot.host.style.setProperty('--form-placeholder-color', '#00884d');
      form.shadowRoot.host.style.setProperty('--form-field-border-radius', '0px');
      form.shadowRoot.host.style.setProperty('--form-field-border', '0 0 0 1px #00884d');
      form.shadowRoot.host.style.setProperty('--form-background-color', 'none');
      form.shadowRoot.host.style.setProperty('--button-border-radius', '0px');
      form.shadowRoot.host.style.setProperty('--button-background-color', 'none');
      
      const paths = form.shadowRoot.querySelectorAll('svg path');
      paths.forEach(path => {
        path.setAttribute('fill', '#00884d');
      });
      const submit = form.shadowRoot.querySelector('button[type="submit"]');
      submit.style.border = '1px solid #00884d';
    }
  });
}
document.addEventListener('DOMContentLoaded', setShopifyFormsColor);
//フォームの追加・再描画にも対応
const observer = new MutationObserver(setShopifyFormsColor);
observer.observe(document.body, { childList: true, subtree: true });


function about_img() {
  gsap.set('#about_main img', { opacity: 0 });
  gsap.to('#about_main img', {
    opacity:1,
    duration: 0.3,
    ease: 'none',
    scrollTrigger: {
      trigger: '#about_img',
      start: "center center",
      toggleActions: "play none none reverse",
    }
  });
  // gsap.to('#about_bg .img', {
  //   yPercent: -25,
  //   ease: 'none',
  //   scrollTrigger: {
  //     trigger: '#about_img_wrap',
  //     start: "top bottom",
  //     end: "bottom top",
  //     scrub: true,
  //   }
  // });
}

function about_page_mainimg() {
  gsap.to('#about_main_img .img', {
    opacity:0,
    duration: 0.3,
    ease: 'none',
    scrollTrigger: {
      trigger: '#statement_footer',
      start: "top top",
      toggleActions: "play none none reverse",
    }
  });
}

function variantImageSwitch() {
  if (!window.productVariants) return;
  const productForm = document.querySelector('#product_single form.product_form');
  if (!productForm) return;
  
  const swiper = document.querySelector('.item_slider')?.swiper;
  const optionInputs = productForm.querySelectorAll('input[type="radio"][name^="options"]');
  const priceElement = document.querySelector('#product_single .title_set .price');
  const variantIdInput = productForm.querySelector('input[name="id"]');
    
  const updateVariant = () => {
    const selectedOptions = [];
    optionInputs.forEach(input => {
      if (input.checked) {
        selectedOptions.push(input.value);
      }
    });    
    const matchedVariant = window.productVariants.find(variant => {
      return variant.options.every((opt, idx) => opt === selectedOptions[idx]);
    });
    if (matchedVariant) {
      // Update hidden variant ID
      if (variantIdInput) {
        variantIdInput.value = matchedVariant.id;
      }
      
      // Update price
      if (priceElement) {
        let priceHTML = '';
        if (matchedVariant.compare_at_price) {
          priceHTML = `<s>${matchedVariant.compare_at_price}</s><br>\n`;
        }
        priceHTML += `${matchedVariant.price}`;
        priceElement.innerHTML = priceHTML;
      }
      
      // Update image (only if swiper exists)
      if (swiper && window.productImages && matchedVariant.featured_image) {
        const imageIndex = window.productImages.findIndex(img => img === matchedVariant.featured_image);
        if (imageIndex !== -1) {
          swiper.slideToLoop(imageIndex, 300);
        }
      } else if (window.productImages && matchedVariant.featured_image) {
        const imageIndex = window.productImages.findIndex(img => img === matchedVariant.featured_image);
        if (imageIndex !== -1) {
          const slides = document.querySelectorAll('.item_slider .swiper-slide');
          if (slides[imageIndex]) {
            slides[imageIndex].scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }
    }
  };
  
  optionInputs.forEach(input => {
    input.addEventListener('change', updateVariant);
  });
}

function footer_color() {
  const footer = document.querySelector('#footer');
  const footer_bg = document.querySelector('#footer_bg');
  footer_bg.style.opacity = 0;

  const getRandomColor = () => {
    const h = Math.floor(Math.random() * 360);
    return `hsl(${h}, 40%, 65%)`;
  };

  gsap.to(footer_bg, {
    opacity: 1,
    ease: 'none',
    scrollTrigger: {
      trigger: footer,
      start: "top 20%",
      end: "bottom bottom",
      scrub: 2,
    }
  });

  ScrollTrigger.create({
    trigger: footer,
    start: "top 20%",
    end: "bottom bottom",
    scrub: true,
    onEnter: () => footer_bg.style.backgroundColor = getRandomColor(),
  });
}

async function nav_play_font() {
  const playLink = document.getElementById('nav-play');
  const mainNav = document.getElementById('main_nav');
  if (!playLink || !mainNav) return;

  async function fetchTrendingFonts(apiKey) {
    const res = await fetch(
      `https://www.googleapis.com/webfonts/v1/webfonts?key=${apiKey}&sort=trending`,
      { referrerPolicy: 'origin' }
    );
    if (!res.ok) throw new Error(`Google Fonts API error: ${res.status}`);
    const data = await res.json();
    return data.items
      .filter(f => f.subsets.includes('latin'))
      .map(f => f.family);
  }
  const fallbackFonts = [
    'Roboto', 'Open Sans', 'Lato', 'Montserrat', 'Oswald',
    'Raleway', 'Poppins', 'Merriweather', 'Nunito', 'Playfair Display',
    'Josefin Sans', 'Abril Fatface', 'Dancing Script', 'Pacifico', 'Lobster',
    'Bebas Neue', 'Fjalla One', 'Cinzel', 'Cormorant Garamond', 'Space Mono',
    'Bodoni Moda', 'Fraunces', 'Syne', 'DM Serif Display', 'Italiana'
  ];
  let pool;
  const apiKey = window.__THEME__?.googleFontsApiKey;
  if (apiKey) {
    try {
      pool = await fetchTrendingFonts(apiKey);
    } catch (e) {
      console.warn('Google Fonts API fetch failed, using fallback.', e);
      pool = fallbackFonts;
    }
  } else {
    pool = fallbackFonts;
  }

  const fonts = [...pool].sort(() => Math.random() - 0.5).slice(0, 50);

  const fontFamilies = fonts.map(f => `family=${f.replace(/ /g, '+')}`).join('&');
  const link = document.createElement('link');
  link.href = `https://fonts.googleapis.com/css2?${fontFamilies}&text=Play&display=swap`;
  link.rel = 'stylesheet';
  // link.onloadでCSSの解析完了（@font-face登録）を待つ
  await new Promise(resolve => {
    link.onload = resolve;
    link.onerror = resolve;
    document.head.appendChild(link);
  });
  await Promise.allSettled(fonts.map(f => document.fonts.load(`400 1em "${f}"`, 'Play')));

  let fontInterval = null;
  let currentIndex = 0;

  const startInterval = () => {
    if (fontInterval) return;
    playLink.style.fontFamily = `'${fonts[currentIndex]}', sans-serif`;
    fontInterval = setInterval(() => {
      currentIndex = (currentIndex + 1) % fonts.length;
      playLink.style.fontFamily = `'${fonts[currentIndex]}', sans-serif`;
    }, 400);
  };

  const stopInterval = () => {
    clearInterval(fontInterval);
    fontInterval = null;
  };

  // main_navのis-openクラス変化を監視してインターバルを制御
  new MutationObserver(() => {
    mainNav.classList.contains('is-open') ? startInterval() : stopInterval();
  }).observe(mainNav, { attributes: true, attributeFilter: ['class'] });
}

function favicon_random() {
  const link = document.querySelector("link[rel~='icon']");
  if (!link) return;
  const icons = [...(window.__THEME__?.favicons ?? [])].sort(() => Math.random() - 0.5);
  if (!icons.length) return;
  let index = 0;
  setInterval(() => {
    link.href = icons[index];
    index = (index + 1) % icons.length;
  }, 1000);
}

// Cart drawer インスタンスをグローバルに保存
let cartDrawerInstance;

function initialize(){
	body.classList.add('ready');
	cartDrawerInstance = cart_drawer();
  modalFunc();
  navInit();
	anchorLink();
  elFunc();
  footer_color();
  nav_play_font();
  // favicon_random();
}

window.addEventListener('load', function () {
	initialize();
});

if( document.getElementById('top_hero') ){
  logo_3d();
}
if( document.getElementById('top_about') ){
  about_img();
}
if( document.getElementById('product_single') ){
	imageSlide();
  variantImageSwitch();
}
if( document.querySelectorAll('.recommend_swiper') ){
	recommendSlide();
}
if( document.getElementById('page_about') ){
	about_page_mainimg();
}

})();